var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "House with heart",
    clipPath: "url(#clip0_2_282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork_24_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5_24_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.2901 13.9323L18.1046 2.87647C16.9471 1.90588 15.0529 1.90588 13.8955 2.87647L0.70991 13.9323C-0.447629 14.9028 -0.158844 15.6969 1.3518 15.6969H4.51053C4.51053 15.6969 4.83075 15.7111 4.83075 16C4.83075 18.9136 4.83075 27.6543 4.83075 27.6543C4.83075 28.8677 5.81452 29.8515 7.02798 29.8515H24.972C26.1856 29.8515 27.1692 28.8678 27.1692 27.6543C27.1692 27.6543 27.1692 18.8972 27.1692 15.9783C27.1692 15.7112 27.4593 15.697 27.4593 15.697H30.6482C32.1589 15.6969 32.4478 14.9028 31.2901 13.9323ZM21.5504 21.6701C20.6617 23.0218 16.8353 26.2361 16.0058 26.2361C15.1939 26.236 11.3328 23.0102 10.4496 21.6701C10.0076 20.9994 9.69394 20.2589 9.74575 19.2858C9.83816 17.5633 11.2465 16.1407 12.9714 16.1407C14.7447 16.1408 15.7774 18.0327 16.0001 18.0328C16.255 18.0328 17.3317 16.1407 19.0288 16.1408C20.7538 16.1407 22.1621 17.5631 22.2543 19.2857C22.3064 20.2589 21.9937 20.9963 21.5504 21.6701Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseicon);
export default __webpack_public_path__ + "static/media/Houseicon.0e2acc91c026ce3b15e18fb899ef58f4.svg";
export { ForwardRef as ReactComponent };